<template lang="html">
  <transition>
    <div v-if="visible" class="modal" @click.self="$emit('close')">
      <div class="container">
        <h1>edit {{newTodoProject}}</h1>
        <TodoInput class="nameinput" v-model="newTodoProject" key="todoInputProject" type="text" placeholder="Project"/>

        <footer>
          <TodoButton class="leftButton" :icon="'close'" :label="'close'" @click="$emit('close')"></TodoButton>
          <TodoButton class="rightButton" label="Save" :icon="'plus'" @click="$emit('confirm', newTodoProject)"></TodoButton>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import TodoButton from '@/components/TodoButton.vue';
import TodoInput from '@/components/TodoInput.vue';

export default {
  components: {
    TodoButton,
    TodoInput,
  },
  created() {
    this.newTodoProject = this.name;
  },
  data() {
    return {
      newTodoProject: '',
    };
  },
  props: {
    visible: Boolean,
    icon: String,
    label: String,
    id: Number,
    name: String,
  },
  watch: {
    name(newValue) {
      this.newTodoProject = newValue; // allows so set a new value for newTodoProject
    },
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.modal
  filter: drop-shadow(2px 2px 8px rgba(67, 249, 206, 1))
  position: fixed
  top: 0
  margin-top: 50px
  left: 0
  right: 0
  bottom: 0
  z-index: 11
  display: flex
  justify-content: center

  @media $tablet
    left: auto
    margin-top: 80px

  &.v-enter-active,
  &.v-leave-active
    transition: opacity 350ms ease

    &.v-enter-active .container,
    &.v-leave-active .container
      transition: transform 350ms ease

    &.v-enter,
    &.v-leave-to
      opacity: 0

      &.v-enter .container,
      &.v-leave-to .container
        transform: translateY(2rem)

  .container
    background-image: radial-gradient(farthest-side at 100% 55%, rgba(255,0,0,0), rgba(255,191,204,0.3)0%, rgba(255,0,0,0)40%), radial-gradient(farthest-side at 80% 40%, rgba(255,0,0,0), rgba(120,108,254,0.5)0%, rgba(255,0,0,0)40%), radial-gradient(closest-side at 30% 18%, rgba(255,0,0,0), rgba(120,108,254,0.5)0%, rgba(255,0,0,0)40%), radial-gradient(closest-side at 20% 15%, rgba(255,0,0,0), rgba(0,209,255,0.3)0%, rgba(255,0,0,0)40%), radial-gradient(farthest-side at 10% 105%, rgba(255,0,0,0), rgba(133,244,194,0.3)0%, rgba(255,0,0,0)40%), radial-gradient(farthest-side at 30% 115%, rgba(255,0,0,0), rgba(120,108,254,0.5)0%, rgba(255,0,0,0)40%)
    background-color: black
    color: white
    width: 100%
    max-width: 640px
    border-radius: 2px
    font-family: futura-pt, sans-serif
    font-weight: 400;
    font-style: normal
    text-transform: uppercase

    @media $tablet
      max-width: 440px
      min-width: 440px

    button
      margin-left: auto
      background-color: black
      color: white
      border: none
      border-radius: 50%
      cursor: pointer
      font-family: futura-pt, serif
      font-weight: 400
      font-style: normal
      font-size: 16px
      text-transform: uppercase
      padding: 10px
      padding-right: 15px
      padding-left: 5px
      border-radius: 2px
      display: inline-flex
      align-items: center
      bottom: 0
      margin-bottom: 20px

      .label
        width: 20px
        height: 20px
        margin-right: 20px

      &:focus
        color: #C9D9D6
        background-color: transparent
        border: none
        outline: none
        border: solid 0.5px white

      &:active
        color: #C9D9D6
        background-color: transparent
        border: none
        outline: none
        border: solid 0.5px white

      &:hover
         color: #C9D9D6
         background-color: transparent
         border: none
         outline: none
         border: solid 0.5px white

    .leftButton
      position: absolute
      display: inline-flex
      align-items: center
      left:0
      color: white
      margin-left: 30px
      bottom: 20px
      background-color: black
      border-radius: 2px
      border-top: solid 0.5px white
      border-bottom: solid 0.5px white
      font-family: futura-pt, serif
      font-weight: 400
      font-style: normal
      text-transform: uppercase
      font-size: 16px
      >>> .icon
        width: 15px
        height: 15px

    .rightButton
      position: absolute
      right:0
      margin-right: 30px
      bottom: 20px
      display: inline-flex
      align-items: center
      color: white !important
      background-color: black
      border-radius: 2px
      font-family: futura-pt, serif
      font-weight: 400
      font-style: normal
      text-transform: uppercase
      font-size: 16px
      border-top: solid 0.5px white
      border-bottom: solid 0.5px white
      >>> .icon
        width: 15px
        height: 15px

    h1
      font-family: operetta-8, serif
      font-weight: 700
      font-style: normal
      text-transform: lowercase
      text-align: left
      font-size: 30
      margin-top: 50px
      margin-left: 30px !important
      padding-left: 0px !important
      margin-bottom: 30px
      padding-top: 0px !important
      overflow: hidden
      text-overflow: ellipsis

      @media $tablet
        margin-top: 70px
        margin-bottom: 23px

</style>
